const NotFound = () => {
    return (
        <>
            <div className="container h-100 mt-5">
                <div className="row h-100 justify-content-center py-5 align-items-center">
                    <div className="col-md-6 text-center">
                        <img alt="logo" className="acband-price-icon animate-logo" src={require('../../assets/media/logo/final.png')} />
                        <p className="fw-bold mt-3">
                            صفحه مورد نظر پیدا نشد
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NotFound;